import {Injectable, signal, TemplateRef} from '@angular/core';

@Injectable({providedIn: 'root'})
export class SidebarSlidePanelSlot {
  private readonly templateSignal = signal<TemplateRef<unknown> | undefined>(undefined);
  readonly template = this.templateSignal.asReadonly();

  setTemplate(template: TemplateRef<unknown>): void {
    this.templateSignal.set(template);
  }

  clearTemplate(template: TemplateRef<unknown>): void {
    if (this.template() === template) {
      this.templateSignal.set(undefined);
    }
  }
}
